import { createServerFn } from "@tanstack/react-start";

/**
 * Analytics configuration payload
 */
export interface AnalyticsConfigPayload {
  /**
   * Google Tag Manager ID (e.g., GTM-XXXXXX)
   * null if GTM is disabled
   */
  gtmId: string | null;
}

/**
 * Server Function to retrieve analytics configuration from runtime environment variables.
 *
 * This function reads GTM_ID from process.env at runtime, allowing dynamic configuration
 * via Kubernetes Pod environment variables without rebuilding the Docker image.
 *
 * @returns Analytics configuration including GTM ID
 *
 * @example
 * ```tsx
 * const { gtmId } = await getAnalyticsConfigServer();
 * if (gtmId) {
 *   // Inject GTM script
 * }
 * ```
 */
export const getAnalyticsConfigServer = createServerFn({ method: "GET" }).handler(
  async (): Promise<AnalyticsConfigPayload> => {
    const gtmId = process.env.GTM_ID || null;

    return { gtmId };
  },
);
